<mobile-page-content [fullPageWidth]="true" class="page-content">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <ng-container *ngIf="null === exercise">
        <div fxLayout="column" fxLayoutAlign="center center" style="height: 100%">
            <div>
                {{ 'Exercise_no_longer_exists' | translate }}
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="null !== exercise">
        <module-content *ngIf="!is401 && !is404 && !isLoading" [title]="pageTitle">
          <session-exercice-duration *ngIf="data.data.exercice.exercice.exerciceType === EXERCISE_TYPE_DURATION"
                                     [data]="data"
                                     [organization]="organization"
                                     [isEditable]="false">
          </session-exercice-duration>
          <session-exercice-repeat *ngIf="data.data.exercice.exercice.exerciceType === EXERCISE_TYPE_REPEAT"
                                   [data]="data"
                                   [sessionId]="sessionId"
                                   [organization]="organization"
                                   [isEditable]="false">
          </session-exercice-repeat>
        </module-content>
    </ng-container>
</mobile-page-content>
